var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "	<div class=\"phase phase--"
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + " js_phase\" style=\"left: "
    + alias2(alias1((depth0 != null ? depth0.left : depth0), depth0))
    + "px;\n"
    + ((stack1 = helpers["if"].call(alias3,__default(require("../../../common/js/handlebars/eq.js")).call(alias3,(depth0 != null ? depth0.type : depth0),"normal",{"name":"eq","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "		<span class=\"phase__label\" style=\"left: "
    + alias2(alias1((depth0 != null ? depth0.labelLeft : depth0), depth0))
    + "px"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.labelHidden : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</span>\n	</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "			width: "
    + alias2(alias1((depth0 != null ? depth0.width : depth0), depth0))
    + "px;\n			background-color: #"
    + alias2(alias1((depth0 != null ? depth0.color : depth0), depth0))
    + "\">\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "			color: #"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.color : depth0), depth0))
    + "\">\n			"
    + ((stack1 = helpers["if"].call(alias1,__default(require("../../../common/js/handlebars/present.js")).call(alias1,(depth0 != null ? depth0.symbol : depth0),{"name":"present","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "<span class=\"phase__symbol\"><i class=\"fa "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.symbol : depth0), depth0))
    + "\"></i></span>";
},"7":function(container,depth0,helpers,partials,data) {
    return "; visibility: hidden";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});